import { TransactionTypeShort } from "ts/types/Transaction"

import { variantTranslationObj } from "./SetupClassTeacher.config"

export const getSetupClassTranslation = (variant: TransactionTypeShort) => {
  return variantTranslationObj[variant]
}
